const newsArea = document.querySelector('.p-top-news');
const newsList = [...document.querySelectorAll('.js-news-target li')];

if(newsList.length < 3) {
  newsArea.classList.add('is-little')
}